<template>
    <ToggleSimple ref="toggleComponent" @update:open="toggleOpen = $event" :default="defaultToggle">
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}
                    <span v-if="count.selected && count.selected > 0">{{ count.selected }}</span>
                </div>
                <div v-if="$te(`fields.${name}.description_short`)" class="toggle-description">
                    {{ $t(`fields.${name}.description_short`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div :class="cssClassOptions">
                <CustomIncludesExcludes
                    v-model="options"
                    v-if="count.selected > 0"
                    :inputKey="name"
                    :showRequired="false"
                    :smHorizontal="!narrow"
                    @update:modelValue="onListsChanged"
                />

                <form @submit.prevent="onSubmit" class="form-type-0 single-field-form">
                    <CustomInput
                        :modelValue="newValue"
                        :inputKey="`${name}`"
                        @update:modelValue="handleCommaSeparatedInput"
                        :showLabel="false"
                    />
                    <button v-if="showAddButton" type="submit" class="btn-1">
                        <div class="icon-plus-pos"></div>
                    </button>
                </form>
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
import { nextTick } from 'vue';
import ToggleSimple from '@/components/elements/misc/ToggleSimple';
import CustomIncludesExcludes from '@/components/elements/inputs/CustomIncludesExcludes';
import CustomInput from '@/components/elements/inputs/CustomInput';

export default {
    name: 'OptionsPageSearch',
    components: { ToggleSimple, CustomIncludesExcludes, CustomInput },
    props: {
        modelValue: {
            type: Object,
            default: () => ({ includes: [], excludes: [] })
        },
        defaultVal: {
            type: Object,
            default: () => ({ includes: [], excludes: [] })
        },
        defaultToggle: { type: Boolean, default: false },
        showDescriptions: { type: Boolean, default: true },
        cssClassOptions: { type: String, default: 'options-type-4' },
        narrow: { type: Boolean, default: false },
        showAddButton: { type: Boolean, default: true }
    },
    data() {
        return {
            name: 'prospects_filter_pagesearch',
            toggleOpen: this.defaultToggle,
            options: {
                includes: this.modelValue?.includes || [],
                excludes: this.modelValue?.excludes || []
            },
            newValue: ''
        };
    },
    computed: {
        isActive() {
            return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal);
        },
        excludedValues() {
            return [
                ...this.options.includes.map(app => app.value),
                ...this.options.excludes.map(app => app.value)
            ];
        },
        count() {
            return {
                total: this.options.includes.length + this.options.excludes.length,
                selected: this.options.includes.length + this.options.excludes.length,
                includes: this.options.includes.length,
                excludes: this.options.excludes.length
            };
        }
    },
    methods: {
        resetSection(event = null) {
            if (event) event.stopPropagation();
            this.options = { includes: [], excludes: [] };
            this.emitUpdate();
        },
        onSubmit() {
            if (this.newValue.trim()) {
                this.processInput(this.newValue);
                this.newValue = '';
            }
        },
        handleCommaSeparatedInput(newValue) {
            if (newValue.includes(',')) {
                this.processInput(newValue);
                this.newValue = newValue.split(',').pop().trim();
            } else {
                this.newValue = newValue;
            }
        },
        processInput(newInput) {
            const parts = newInput.split(',').map(part => part.trim()).filter(part => part);
            parts.forEach(term => {
                if (!this.options.includes.some(item => item.value === term)) {
                    this.options.includes.push({ value: term, text: term });
                }
            });
            this.emitUpdate();
        },
        onListsChanged(newValue) {
            this.options = { includes: newValue.includes, excludes: newValue.excludes };
            this.emitUpdate();
        },
        emitUpdate() {
            nextTick(() => {
                this.$emit('update:modelValue', this.options);
            });
        }
    },
    watch: {
        modelValue: {
            handler(newVal) {
                this.options = { includes: newVal?.includes || [], excludes: newVal?.excludes || [] };
            },
            immediate: true
        }
    }
};
</script>